import { ComponentsData, ProducersData } from "./components/ComponentsForm";
import { Components, Producer } from "./types";
export function producerToProducerData(
  producer?: Producer
): ProducersData | undefined {
  if (!producer) return undefined;
  const {
    contactEmail,
    contactPhone,
    portalAccessLink,
    portalAccessPassword,
    portalAccessUsername: portalAccessUser,
  } = producer;
  const producerData: ProducersData = {
    producerContactEmail: contactEmail,
    producerContactPhone: contactPhone,
    producerPortalAccessLink: portalAccessLink,
    producerPortalAccessPassword: portalAccessPassword,
    producerPortalAccessUsername: portalAccessUser,
  };
  return producerData;
}
export function producersToProducersData(
  producers?: Producer[]
): ProducersData[] | undefined {
  if (!producers) return undefined;
  const producersData: ProducersData[] = producers
    .map((producer) => producerToProducerData(producer))
    .filter((producerData) => producerData !== undefined) as ProducersData[];
  return producersData;
}
export function producerDataToProducer(
  producerData?: ProducersData
): Producer | undefined {
  if (!producerData) return undefined;

  const {
    producerContactEmail,
    producerContactPhone,
    producerPortalAccessLink,
    producerPortalAccessPassword,
    producerPortalAccessUsername,
  } = producerData;
  const producer: Producer = {
    contactEmail: producerContactEmail ?? undefined,
    contactPhone: producerContactPhone ?? undefined,
    portalAccessLink: producerPortalAccessLink ?? undefined,
    portalAccessPassword: producerPortalAccessPassword ?? undefined,
    portalAccessUsername: producerPortalAccessUsername ?? undefined,
  };
  return producer;
}
export function producersDataToProducers(
  producersData?: ProducersData[]
): Producer[] | undefined {
  if (!producersData) return undefined;
  const producers: Producer[] = producersData
    .map((producerData) => producerDataToProducer(producerData))
    .filter((producer) => producer !== undefined) as Producer[];
  return producers;
}

export function componentsToComponentsData(
  components?: Components
): ComponentsData | undefined {
  if (!components) return undefined;
  const { inverters, modules, string, trackers } = components;
  const componetsData: ComponentsData = {
    inverterPower: inverters?.inverterPower,
    invertersAmount: inverters?.amount,
    invertersProducers: producersToProducersData(inverters?.producers),
    modulesAmount: modules?.amount,
    modulesPower: modules?.power,
    modulesProducers: producersToProducersData(modules?.producers),
    stringAmount: string?.amount,
    stringPower: string?.power,
    trackersAmount: trackers?.amount,
    trackersProducers: producersToProducersData(trackers?.producers),
  };
  return componetsData;
}

export function componetsDataToComponents(
  componetsData?: ComponentsData,
  hasTrackers: boolean = true
): Components | undefined {
  if (!componetsData) return undefined;
  const {
    inverterPower,
    invertersAmount,
    invertersProducers,
    modulesAmount,
    modulesPower,
    modulesProducers,
    stringAmount,
    stringPower,
    trackersAmount,
    trackersProducers,
  } = componetsData;
  const components: Components = {
    inverters: {
      amount: invertersAmount ?? undefined,
      inverterPower: inverterPower ?? undefined,
      producers: producersDataToProducers(invertersProducers),
    },
    modules: {
      amount: modulesAmount ?? undefined,
      power: modulesPower ?? undefined,
      producers: producersDataToProducers(modulesProducers),
    },
    string: {
      amount: stringAmount ?? undefined,
      power: stringPower ?? undefined,
    },
    trackers: hasTrackers
      ? {
          amount: trackersAmount ?? undefined,
          producers: producersDataToProducers(trackersProducers),
        }
      : undefined,
  };
  return components;
}
